import { render, staticRenderFns } from "./PrismsUserListing.vue?vue&type=template&id=2a090fae&"
import script from "./PrismsUserListing.vue?vue&type=script&lang=js&"
export * from "./PrismsUserListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports